import _isEqual from "lodash/isEqual";
import _throttle from "lodash/throttle";
import React from "react";
import ContentPane from "../subcomponents/home/ContentPane";
import Navigation from "../subcomponents/home/Navigation";
import { connect } from "react-redux";
import {
    navBarToggle,
    pageLoaded,
    startProgressTracker,
    updateScrollingStats,
} from "../../redux/actions/navigation";
import {
    loadAvailableArchives,
    loadNewsletterData,
    loadNewsletters,
    loadTemporaryNewsletterData,
} from "../../redux/actions/newsletters";
import Swipe from "react-easy-swipe";
import { getNewsletterContentBackgroundColor } from "../../redux/selectors/template";
import { getAllDomArticlesMap } from "../../util/dom";
import { isMobile } from "../../util/screen";
import { getCurrentNewsletterName } from "../../redux/selectors/newsletters";

class Home extends React.Component {
    constructor(props) {
        super(props);
        window.onscroll = props.onUpdateScrollStats.bind(this);
    }

    componentDidMount() {
        this.initialize();
    }

    componentDidUpdate(prevProps) {
        const newParams = this.props.match.params;
        const oldParams = prevProps.match.params;
        const paramsChanged = !_isEqual(newParams, oldParams);
        const newsletterName = this.props.newsletterTitle;
        const titleChanged = document.title != newsletterName;
        if (titleChanged && newsletterName) {
            document.title = newsletterName;
        }
        if (paramsChanged) {
            this.initialize();
        }
    }

    initialize() {
        const props = this.props;
        const {
            newsletterTempId,
            groupingId,
            date,
            accessKey,
        } = props.match.params;
        props.onLoadPage(props);

        if (accessKey) {
            props.onLoadNewsletters(accessKey);

            if (groupingId) {
                props.onLoadAvaliableArchives(accessKey, groupingId);

                if (newsletterTempId) {
                    // Temporary newsletter
                    props.onLoadTemporaryNewsletterData(
                        accessKey,
                        groupingId,
                        newsletterTempId
                    );
                } else {
                    // Regular newsletter
                    props.onLoadNewsletterData(accessKey, groupingId, date);
                }
            }
        }
    }
    /**
     * Render the component based on the state and props (will be called every time state changes with setState)
     * @returns {*}
     */
    render() {
        // Layout borrowed from https://www.codeply.com/go/Rgq96HykJ2/sidebar-that-changes-to-navbar
        return (
            <Swipe onSwipeMove={this.props.onSwipeMove}>
                <div
                    className="container-fluid"
                    style={{ backgroundColor: this.props.contentBackground }}
                >
                    <div className="row flex-nowrap">
                        <Navigation />
                        <ContentPane />
                    </div>
                </div>
            </Swipe>
        );
    }
}
/**
 * mapStateToProps returns the parts of the state that will be available as props
 * @param state
 * @returns {*}
 */
const mapStateToProps = (state) => {
    return {
        contentBackground: getNewsletterContentBackgroundColor(state),
        newsletterTitle: getCurrentNewsletterName(state),
    };
};

/**
 * mapDispatchToProps exposes the actions we want to call as props
 * @param state
 * @returns {{navigation: *}}
 */
const mapDispatchToProps = (dispatch) => {
    return {
        onNavBarToggled: () => {
            dispatch(navBarToggle());
        },
        onSwipeMove: (position, event) => {
            if (isMobile()) {
                const threshold = 100; //how many pixels should a user move before we consider it a swipe
                if (position.x > threshold) {
                    dispatch(navBarToggle(true));
                } else if (position.x < -threshold) {
                    dispatch(navBarToggle(false));
                }
            }
        },
        onLoadPage: (props) => {
            dispatch(pageLoaded(props.match.params, props.location.hash));
        },
        onLoadNewsletters: (accessKey) => {
            dispatch(loadNewsletters(accessKey));
        },
        onLoadAvaliableArchives: (accessKey, groupingId) => {
            dispatch(loadAvailableArchives(accessKey, groupingId));
        },
        onLoadNewsletterData: (accessKey, groupingId, date) => {
            dispatch(loadNewsletterData(accessKey, groupingId, date));
        },
        onLoadTemporaryNewsletterData: (
            accessKey,
            groupingId,
            newsletterTempId
        ) => {
            dispatch(
                loadTemporaryNewsletterData(
                    accessKey,
                    groupingId,
                    newsletterTempId
                )
            );
        },
        onUpdateScrollStats: _throttle(
            () => {
                dispatch(updateScrollingStats());
            },
            200,
            {
                leading: true,
            }
        ),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
